<template>
  <div class="signupInitSelectMethodWrapper">
    <FacebookBtn @click="$emit('input', 'FacebookUser')">
      <div class="btnText">
        <i class="fab fa-facebook-f"></i>
        <span>{{ $t("band.signup.init.selectMethod.button.facebook") }}</span>
      </div>
    </FacebookBtn>
    <div class="orBar">
      <div class="line"></div>
      <div class="text">{{ $t("common.or") }}</div>
      <div class="line"></div>
    </div>
    <MainBtn @click="$emit('input', 'ClassicUser')">
      <div class="btnText">
        <i class="far fa-envelope"></i>
        <span>{{ $t("band.signup.init.selectMethod.button.classic") }}</span>
      </div>
    </MainBtn>
  </div>
</template>
<script>
import MainBtn from "~/components/shared/mainBtn"
import FacebookBtn from "~/components/shared/facebookBtn"

export default {
  components: {
    MainBtn,
    FacebookBtn,
  },
  props: {
    value: {
      type: String,
      required: true,
      validator(value) {
        return !value.length || ["FacebookUser", "ClassicUser"].includes(value)
      },
    },
  },
}
</script>
<style scoped>
.orBar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 24px 0px;
}

.orBar .line {
  width: 100%;
  height: 1px;
  background-color: var(--color-light-grey);
}

.orBar .text {
  color: var(--color-dark-grey);
  font-weight: 600;
  margin: 0px 24px;
}
</style>
